import type { SmsSettings } from '$lib/model/customer-communication';
import { apiStore } from '$lib/stores/api';
import type { Axios } from 'axios';
import { get, writable } from 'svelte/store';
import { DateTime } from 'luxon';
import { loadTagsFromData } from '$lib/stores/tags';

export type SmsSent = {
	id: number;
	type: string;
	sent_at_date: DateTime;
	sent_at: string;
	phone_number: string;
	business: string;
	content: string;
};

export type SmsSentApi = Omit<SmsSent, 'sent_at'> & { sent_at: string };

export const smsSettingsStore = writable<SmsSettings | null>(null);

export function loadSmsSettings() {
	(get(apiStore) as Axios).get<SmsSettings>('/business/sms-settings').then((res) => {
		loadSmsSettingsFromData(res.data);
	});
}

export function loadSmsSettingsFromData(data: SmsSettings) {
	smsSettingsStore.set(data);
}

export type SmsPacks = {
	[key: string]: number;
};

export const smsPacksStore = writable<SmsPacks | null>(null);

export function loadSmsPacksFromData(data: SmsPacks) {
	smsPacksStore.set(data);
}

export const GSM_CHARACTERS_REGEX =
	/^[A-Za-z0-9 \r\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!"#$%&\'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\[~\]|\u20AC]*$/;

export function sanitizeToGSM(text: string) {
	return [...text].filter((char) => GSM_CHARACTERS_REGEX.test(char)).join('');
}
